import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  PRODUCT_REFERENCE_PRICE_TYPE,
  type ProductReferencePriceType,
} from '../../../model/productAccessor/productAccessorReferencePrice'

type ProductReferencePriceLabelProps = {
  referencePriceType: ProductReferencePriceType | null
}

export const ProductReferencePriceLabel: FC<
  ProductReferencePriceLabelProps
> = ({ referencePriceType }) => {
  switch (referencePriceType) {
    case PRODUCT_REFERENCE_PRICE_TYPE.AVP: {
      return <FormattedMessage id="product.referencePrice.label.avp" />
    }
    case PRODUCT_REFERENCE_PRICE_TYPE.UVP: {
      return <FormattedMessage id="product.referencePrice.label.uvp" />
    }
    default: {
      return null
    }
  }
}
